export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Navegação</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>

          <a className='navbar-brand page-scroll' href='#page-top'>
            <img src="img/sm4rt/logo.png" width="220"/>
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>

            <li>
              <a href='#features' className='page-scroll'>
                Proteção de dados
              </a>
            </li>

            <li>
              <a href='#services' className='page-scroll'>
                Nossos diferenciais
              </a>
            </li>

            <li>
              <a href='#about' className='page-scroll'>
                Sobre
              </a>
            </li>

            {/*<li>
              <a
                href='https://app.elza.ai'
                className='btn btn-lg btn-login'
              >
                Cadastre-se
              </a>
            </li>*/}

          </ul>
        </div>
      </div>
    </nav>
  )
}
